import { fontWeight, maxHeight } from "@mui/system";

const styles = (theme) => ({
  titleDescription: {
    fontSize: "15px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",

    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    fontWeight: "regular",
    color:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.light
        : theme.palette.colors.black.medium,
  },
  buttonDetails: {
    width: "80%",
    color: theme.palette.text.main,
    borderColor: theme.palette.text.main,
  },
  boxContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    p: 2,
  },
  boxBodyModal: {
    flex: 1,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 1,
    marginTop: "15px",
  },

  paperBody: {
    width: "100%",
    p: 2,
    borderRadius: "16px",
  },
  boxModal: {
    position: "absolute",
    borderRadius: "16px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "1000px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    minHeight: "400px",
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  containerLoading: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  iconButton: {
    position: "absolute",
    top: 8,
    right: 8,
    zIndex: 1,
  },
  boxIcon: {
    backgroundColor: theme.palette.primary.main,
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5px",
  },
  containerTitle: {
    width: "85%",
    display: "flex",
    gap: 1,
  },
  boxBody: {
    padding: 2,
    display: "flex",
    justifyContent: "space-between",
  },
  chip: {
    color: theme.palette.white.main,
    fontWeight: "bold",
    width: "60px",
  },
  containerButton: {
    p: 2,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  containerMenuItem: {
    display: "flex",
    gap: 1,
  },
  title: {
    fontWeight: "bold",
    fontSize: "20px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "block",
  },
  containerMore: {
    width: "40px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paperContainer: {
    width: "100%",
    borderRadius: "16px",
    backgroundColor: theme.palette.background.wallpaper,
  },
});

export default styles;
